import { User } from 'src/admin/users/types';
import { Select } from 'src/design-system/Select';
import { formatName, NameFormat } from 'src/utils/nameFormatting';

const NO_ADVISOR_FILTER_VALUE = '__no_advisor__';

export function matchesAdvisorFilter(
  advisorUserId: string | null | undefined,
  advisorFilter: string | null,
): boolean {
  if (advisorFilter === null) return true;
  if (advisorFilter === NO_ADVISOR_FILTER_VALUE) return !advisorUserId;
  return advisorUserId === advisorFilter;
}

export function getAdvisorSortValue(
  advisorUserId: string | null | undefined,
  advisorMap: Record<string, User>,
): string {
  if (!advisorUserId) return '';
  const advisor = advisorMap[advisorUserId];
  return advisor ? formatName(advisor.firstName, advisor.lastName) : '';
}

export function matchesAdvisorSearch(
  advisorUserId: string | null | undefined,
  advisorMap: Record<string, User>,
  searchTerm: string,
): boolean {
  if (!advisorUserId) return false;
  const advisor = advisorMap[advisorUserId];
  if (!advisor) return false;
  return formatName(advisor.firstName, advisor.lastName, NameFormat.NATURAL)
    .toLowerCase()
    .includes(searchTerm.toLowerCase());
}

interface AdvisorFilterSelectProps {
  advisors: User[];
  value: string | null;
  onChange: (value: string | null) => void;
}

export function AdvisorFilterSelect({ advisors, value, onChange }: AdvisorFilterSelectProps) {
  const data = [
    { value: NO_ADVISOR_FILTER_VALUE, label: 'No advisor' },
    ...advisors.map(advisor => ({
      value: advisor.id,
      label: formatName(advisor.firstName, advisor.lastName),
    })),
  ];

  return (
    <Select
      placeholder="Filter by advisor"
      data={data}
      value={value}
      onChange={onChange}
      clearable
      searchable
      w={220}
    />
  );
}
